import { axios } from '@inscore/shared';

class AdsApi {
    static getAvailability() {
        const abortController = new AbortController();
        return {
            call() {
                return axios.get('/v1/Ads/availability', {
                    signal: abortController.signal,
                });
            },
            cancel() {
                abortController?.abort();
            },
        };
    }
}

export default AdsApi;
